export const GET_RISK_SCENARIOS_REQUEST = "GET_RISK_SCENARIOS_REQUEST";
